<template>
  <div class="class-settings">
    <div class="container">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="nav">
        <el-breadcrumb-item @click.native="$router.go(-1)">
          <b style="cursor: pointer">章节列表</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>权重设置</el-breadcrumb-item>
      </el-breadcrumb>

      <weight-set
        :weightInfo="weightInfo"
        :hideBack="true"
        :classId="Number($route.query.id)"
        :isEdit="true"
      />
    </div>
  </div>
</template>

<script>
import { studentList } from "@/api/student";
import { courseList } from "@/api/course";
import { classInfo, editClass, classWeightInfo } from "@/api/class";
import {
  assistantList,
  addAssistant,
  delAssistant,
  assistantPermission,
  editAssistantPermission,
} from "@/api/assistant";
import upload from "@/utils/uploadMethod";
import weightSet from "../home/settings.vue";
export default {
  components: { weightSet },
  data() {
    return {
      activeName: "1",
      classInfo: {},
      rules: {
        name: {
          required: true,
          message: "请输入班级名称",
          trigger: "blur",
        },
        icon: {
          required: true,
          message: "请上传班级封面",
          trigger: "blur",
        },
        courseId: {
          required: true,
          message: "请选择课程",
          trigger: "blur",
        },
      },
      lessonList: [],
      show: false,
      //   params: {
      //     classId: this.$route.query.id,
      //     query: "",
      //   },
      aList: [],
      selectedIds: [],
      list: [],
      userId: null,
      showSet: false,
      checkList: [],
      currentAssistantId: null,
      weightInfo: {},
    };
  },
  created() {
    this.getClassInfo();
    this.getWeightInfo();
    this.getCourseList();
    this.getAssistantList();
  },
  methods: {
    // 班级信息
    getClassInfo() {
      this.$loading.show();
      classInfo(this.$route.query.id).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.classInfo = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    // 课程列表
    getCourseList() {
      courseList().then((res) => {
        if (res.code == 0) {
          // console.log(res);
          this.lessonList = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    getWeightInfo() {
      classWeightInfo(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          this.weightInfo = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    //上传图片
    async upload(file, str) {
      const fileUrl = await upload(file);
      this.classInfo[str] = fileUrl;
    },
    // 修改班级信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$loading.show();
          editClass(this.classInfo).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("修改成功");
              this.getClassInfo();
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getList() {
      studentList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
        } else {
          console.log(res);
        }
      });
    },
    // 助教列表
    getAssistantList() {
      assistantList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.aList = res.data;
        } else {
          console.log(res);
        }
      });
    },
    // 新增助教
    handleAdd() {
      this.$loading.show();
      addAssistant({ classId: this.$route.query.id, ids: this.userId }).then(
        (res) => {
          this.$loading.hide();
          if (res.code == 0) {
            this.$message.success("添加成功");
            this.getAssistantList();
          } else {
            this.$message.error(res.msg);
          }
        }
      );
      this.show = false;
      this.userId = null;
    },
    // 获取权限列表
    getAssistantInfo(assistantId) {
      this.$loading.show();
      assistantPermission(assistantId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.checkList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 权限设置
    handleSet() {
      this.$loading.show();
      editAssistantPermission({
        assistantId: this.currentAssistantId,
        list: this.checkList,
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success("设置成功");
        } else {
          this.$message.error(res.msg);
        }
      });
      this.showSet = false;
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map((item) => item.assistantId);
    },
    // 删除助教
    handleDel(ids) {
      this.$confirm(`确定要删除吗?`, {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delAssistant(ids).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getAssistantList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleDelBatch() {
      this.handleDel(this.selectedIds);
    },
  },
};
</script>

<style lang="less" scoped>
.class-settings {
  background-color: rgb(248, 248, 248);
  .container {
    .nav {
      margin: 40px 0;
    }
    .uploader {
      width: 227px;
      height: 152px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &:hover {
        border-color: #409eff;
      }

      .el-icon-plus {
        font-size: 28px;
        color: #8c939d;
        width: 104px;
        height: 104px;
        line-height: 104px;
        text-align: center;
      }

      .upload_img {
        width: 227px;
        height: 152px;
        display: block;
      }
    }

    .el-select {
      width: 100%;
    }
    .btn {
      width: 120px;
    }
    .box {
      padding: 20px;
      .head {
        overflow: hidden;
        ::v-deep .el-input-group__append {
          background-color: #409eff;
          border-color: #409eff;
          color: #fff;
        }
      }

      ::v-deep .assistant_list {
        margin-top: 25px;
        .is-leaf {
          color: #333;
          background-color: #f5f5f5;
        }
      }
    }
  }
  .setting-dialog {
    ::v-deep .el-checkbox {
      display: block;
      margin-bottom: 30px;
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: inherit;
      }
    }
  }
}
</style>
